export default {
  namespaced: true,

  state: {
    isLoggedIn: false,
    data: {}
  },

  getters: {
    /**
     * Get regional groups as object
     * @param {Object} state vuex state
     * @returns {Object<number, string>} regional groups
     */
    regionalGroups (state) {
      if (!state.data.regional_groups) {
        return {}
      }

      return state.data.regional_groups
        .slice()
        .reduce((groups, group) => {
          groups[group.id] = group
          return groups
        }, {})
    }
  },

  mutations: {
    /**
     * Set user data
     * @param {Object} state vuex state
     * @param {Object} data User data
     */
    data (state, data) {
      state.isLoggedIn = true
      state.data = Object.assign({}, state.data, data)
    },

    /**
     * Reset user data
     * @param {Object} state vuex state
     */
    logout (state) {
      state.isLoggedIn = false
      state.data = {}
    },

    /**
     * Set whether registration is completed
     * @param {Object} state vuex state
     * @param {Boolean} status Registration status
     */
    completedRegistration (state, status) {
      state.data.completed_registration = status
    }
  }
}
